import { render, staticRenderFns } from "./Stickers.vue?vue&type=template&id=a51f3f02"
import script from "./Stickers.vue?vue&type=script&lang=js"
export * from "./Stickers.vue?vue&type=script&lang=js"
import style0 from "./Stickers.vue?vue&type=style&index=0&id=a51f3f02&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports